import { Injectable } from '@angular/core';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { turnosAsignados as turnosAsignadosData } from 'app/mock-api/dashboards/turnos-asignados/data';
import { cloneDeep } from 'lodash-es';

@Injectable({providedIn: 'root'})
export class TurnosAsignadosMockApi
{
    private _turnosAsignados: any = turnosAsignadosData;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService)
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Sales - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/dashboards/turnos-asignados')
            .reply(() => [200, cloneDeep(this._turnosAsignados)]);
    }
}
